import { TMapSettings } from '../types'

export const defaultValue: TMapSettings = {
  tileLayer: 'standard',
  isVector: false,
  center: [
    global.defaultMapLon || 8.236315,
    global.defaultMapLat || 46.7976552,
  ],
  zoom: global.defaultMapZoom || 9,
}
